export const MAP_ANIMATION = {
  duration: 1200,
  zoom: 16,
  padding: 60,
  maxZoom: 16
} as const;
